import styled, { css } from "styled-components";
import { rem } from "polished";
import DetailsModal from "../DetailsModal/DetailsModal";

const Label = styled.h3`
	padding-top: ${rem(16)};
	border-top: 1px solid #dbdbdb;
	display: flex;
	justify-content: space-between;
	font-size: ${rem(24)};
	line-height: 1.3;
	font-weight: 700;
	margin-top: ${rem(30)};
	font-family: sans-serif;
	font-weight: 400;

	${({ disabled }) =>
		disabled &&
		css`
			opacity: 0.4;
		`}
`;

const FieldGroupContainer = styled.div`
	font-family: sans-serif;
	&:not(:first-of-type) {
		margin-top: ${rem(32)};
	}
`;

const FieldGroup = ({ title, details, children, id, isDisabled }) => {
	return (
		<FieldGroupContainer>
			<Label id={id} disabled={isDisabled}>
				{title}
				{details && <DetailsModal {...details} />}
			</Label>
			<div role="group" aria-labelledby={id}>
				{children}
			</div>
		</FieldGroupContainer>
	);
};

export default FieldGroup;
